export const LIGHTBOX_PATH = '/widgets/platform/lightbox/:widgetId';
export const DASHBOARD_PATH = '/dashboard/:dashboardId';
export const DASHBOARD_LIGHTBOX_PATH = '/dashboard/:dashboardId/lightbox/:widgetId';
export const ROUTING_DASHBOARD_PATH = '/dashboard/:dashboardId/widget/:widgetId';
export const DASHBOARD_HEADER_WIDGET_ID = 656;
